export enum ErrorViews {
  BOARD_INVITATION_NOT_FOUND = 'boardInvitationNotFound',
  BOARD_NOT_FOUND = 'boardNotFound',
  CARD_NOT_FOUND = 'cardNotFound',
  MALFORMED_URL = 'malformedUrl',
  NOT_FOUND = 'notFound',
  ORG_INVITATION_NOT_FOUND = 'orgInvitationNotFound',
  UNCONFIRMED_BOARD_NOT_FOUND = 'unconfirmedBoardNotFound',
  UNCONFIRMED_ENTERPRISE_NOT_FOUND = 'unconfirmedEnterpriseNotFound',
  UNCONFIRMED_ORG_NOT_FOUND = 'unconfirmedOrgNotFound',
}
